import React from 'react'
import clsx from 'clsx'
import styles from './TeamProgressBar.module.css'

export type TeamProgressStatus = 'failed' | 'done' | 'default' | 'offline'

export interface TeamProgressBarProps {
  progress: number
  status: TeamProgressStatus
  className?: string
}

export function TeamProgressBar({ progress, status, className }: TeamProgressBarProps) {
  const clampedProgress = Math.min(100, Math.max(0, isNaN(progress) ? 0 : progress))

  return (
    <div
      className={clsx(styles.track, className)}
      role="progressbar"
      aria-valuenow={Math.round(clampedProgress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`Progress: ${Math.round(clampedProgress)}%`}
    >
      <div
        className={clsx(styles.fill, styles[`fill_${status}`])}
        style={{ width: `${clampedProgress}%` }}
      />
    </div>
  )
}
